import React, { useRef, useState } from 'react';
import { addXSRFTokenToHeaders } from '../utils/xsrf';
import Button from './Button';

export function NewsletterForm({
  buttonText = 'Subscribe',
  formID = '58467ba3820414419316b188',
  confirmationText = "Great work! We'll keep you in the loop.",
  inputProps = {},
  buttonProps = {},
  className = '',
  ...props
}) {
  const [state, setState] = useState({ done: false });
  const ref = useRef();
  const submit = (e) => {
    if (e) {
      e.preventDefault();
    }
    const email = ref.current.value;
    if (!email || !email.match(/.+@.+\..+/)) {
      alert('Please enter a valid email address');
      return;
    }
    setState({ done: 1 });
    fetch(`/api/v1/form/${formID}/submit`, {
      headers: addXSRFTokenToHeaders({
        accept: 'application/json',
        'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
        'cache-control': 'no-cache',
        'content-type': 'application/json',
        pragma: 'no-cache',
        'sec-fetch-mode': 'cors',
        'sec-fetch-site': 'same-origin',
        'x-csrf-token': 'null',
      }),
      body: JSON.stringify({ data: [{ key: '1o3iu', value: email }] }),
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
    });
  };
  if (state.done) {
    return (
      <div>
        <p>
          <em>{confirmationText}</em>
        </p>
      </div>
    );
  }
  return (
    <form
      className={'p-0 m-0 flex  flex-col items-center ' + className}
      onSubmit={submit}
    >
      <input
        ref={ref}
        type="email"
        name="email"
        required
        placeholder="my.name@gmail.com"
        style={{
          width: '100%',
          background: 'transparent',
          marginBottom: '1rem',
          color: 'rgba(0, 0, 0, 0.3)',
          padding: '.2rem 0',
          fontWeight: 300,
          outline: 'none',
          border: 0,
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        }}
        {...inputProps}
      />
      <Button yellow solid raised {...buttonProps} onClick={submit}>
        {buttonText}
      </Button>
    </form>
  );
}
